<template>
  <div style="height: 100%">
    <cTable
      ref="table"
      :fields="fields"
      :modals="modals"
      :header="header"
      :methods="methods"
      :config="config"
    >
      <template #header>
        <Tabs type="card" v-model="tabName" @on-click="handleTab">
          <TabPane
            v-for="(item, idx) in tabList"
            :key="idx"
            :label="item.name + '(' + item.num + ')'"
            :name="item.status"
          />
        </Tabs>
      </template>
    </cTable>
    <print ref="print" :printData="printData"></print>
  </div>
</template>

<script>
import {
  getClaimList,
  auditClaim,
  getAuditRecord,
  getClaimConfig,
  printClaim,
  // getClaimDuty,
  getStatusNav,
  getBindUser,
  bindAuditUser,
  addClaim,
  editClaim,
  cancelClaim,
  deleteClaim,
  uploadFile,
  deleteFile,
  exportClaim,
  createBill,
  setClaim,
  saveExtend,
  getAmount,
  batchAudit,
  claimFreight,
  saveClaimFreight,
  ordertype,
  checkSale,
  cancelRefuse,
  uploadFreight,
  getReplenish,
  addReplenish,
  delReplenish,
  specialApply,
  uploadFinance,
  upload
} from "@/api/operation_modules/claim_list";
import { getClaimDuty } from "@/api/claim_management/responsible_claim";
import { getSelectType, getKeysType } from "@/api/public";
import { getAllService } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { mapState } from "vuex";
import print from "./print.vue";
import copyClick from "@/utils/copyClick";
export default {
  name: "claim_list",
  components: {
    cTable,
    print
  },

  async mounted() {
    this.selData = (await getClaimConfig()).data.payload;
    this.selData["is_charge"] = [
      { label: this.$t("YES"), value: 1 },
      { label: this.$t("NO"), value: 2 }
    ];
    let country = (await getCountry()).data.payload;
    this.client = (await getAllClient()).data.payload.rows;
    this.checkSale = (await checkSale()).data.payload || {};
    this.checkSale = this.checkSale.check || false;
    this.$refs["table"].checkSale = this.checkSale;
    console.log("this.checkSale :>> ", this.checkSale);
    // this.selData.toStation = (await getPort({ type: 2 })).data.payload;
    // this.selData.clearance_agent = (
    //   await getTransportAgent({ type: 3 })
    // ).data.payload;
    // this.tabList = this.selData.label_type;
    // this.tabName = this.tabList[1].type;
    let allService = (await getAllService()).data.payload;
    this.header.searchs.forEach(async item => {
      if (item.key === "client_id") item.options = this.client;
      if (item.key === "service_id")
        item.options = allService[1]
          .concat(allService[2])
          .concat(allService[3]);
      if (item.key === "salesman_id") item.options = allService[5];
      if (item.key === "verify_id") item.options = allService[20];
      if (item.key === "claim_type") item.options = this.selData.claim_type;
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      // if (item.key === "status") item.options = this.selData.status_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      if (item.key === "verify_status") item.options = this.selData.verify_type;
      if (item.key === "is_claim_agent")
        item.options = this.selData.is_claim_agent;
      if (item.key === "node_type") item.options = this.selData.node_type;
      if (item.key === "type") item.options = this.selData.type;
      if (item.key === "ownership") item.options = this.selData.ownership;
      if (item.key === "to_country" || item.key === "from_country")
        item.options = country.rows;
    });
    this.modals["auditOrder"]["fields"].forEach(async item => {
      if (item.key === "currency") item.options = this.selData.currency;
      if (item.key === "actual_currency") item.options = this.selData.currency;
      if (item.key === "finance_currency") item.options = this.selData.currency;
      if (item.key === "pay_currency") item.options = this.selData.currency;
      if (item.key === "scheme_id") item.options = this.selData.scheme_type;
      if (item.key === "claim_agent_currency")
        item.options = this.selData.currency;
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      if (item.key === "customer_rule") item.options = this.selData.claim_rule;
    });
    this.modals["batchClaim"]["fields"].forEach(async item => {
      if (item.key === "traceker_code")
        item.options = this.selData.is_claim_agent;
    });
    this.modals["claim"]["fields"].forEach(async item => {
      if (item.key === "scheme_id") item.options = this.selData.scheme_type;
      if (item.key === "service_id")
        item.options = allService[1]
          .concat(allService[2])
          .concat(allService[3]);
      if (item.key === "freight_currency") item.options = this.selData.currency;
      if (item.key === "currency") item.options = this.selData.currency;
    });
    this.modals["setFreight"]["table"]["fields"].forEach(async item => {
      if (item.key === "currency") item.options = this.selData.currency;
    });
  },
  methods: {
    getAmount(row) {
      getAmount(row).then(res => {
        if (res.data.status) {
          row.actual_amount = res.data.payload.amount;
        }
      });
    },
    // 打印
    printFun(obj) {
      printClaim(obj).then(res => {
        // if (res.data.payload.length) {
        this.printData = res.data.payload;
        // }
        // this.$refs["print"].print();
      });
    },
    // tab切换
    handleTab() {
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    },
    // 获取颜色
    getColor(status) {
      let color = "";
      switch (status) {
        case 1:
          color = "#ff9900";
          break;
        case 3:
          color = "#ff9900";
          break;
        case 2:
          color = "#ed4014";
          break;
        case 99:
          color = "#19be6b";
          break;
        default:
          color = "#606266";
          break;
      }
      return color;
    }
  },
  computed: {
    ...mapState({
      remindId: state => state.app.remindId
    })
  },
  watch: {
    remindId(newVal) {
      if (newVal) {
        this.$refs["table"].$refs["header"].searchForm["keywords"] = newVal;
        this.$refs["table"].getList();
        this.$store.commit("remindIdFun", 0);
      }
    }
  },
  data() {
    let that = this;
    return {
      checkSale: false,
      client: [],
      printData: {},
      selData: {},
      title: "",
      required: false,
      tabList: [],
      tabName: "",
      config: {
        rowStyle({ row }) {
          return "background-color: " + row.color;
        }
      },
      methods: {
        list: async params => {
          this.tabList = (await getStatusNav()).data.payload;
          if (!this.tabName) {
            this.tabName = this.tabList[1].num
              ? this.tabList[1].status
              : this.tabList[0].status;
          }
          params.status = this.tabName;
          return getClaimList(params);
        },
        auditClaim,
        getAuditRecord,
        getSelectType,
        getKeysType,
        printClaim,
        print: obj => {
          this.printFun(obj);
        },
        uploadFreight,
        getClaimDuty,
        bindAuditUser,
        addClaim,
        editClaim,
        cancelClaim,
        deleteClaim,
        exportClaim,
        createBill,
        setClaim,
        saveExtend,
        getAmount,
        batchAudit,
        claimFreight,
        saveClaimFreight,
        ordertype,
        cancelRefuse,
        getReplenish,
        addReplenish,
        delReplenish,
        specialApply,
        uploadFinance,
        upload
        // getZhongGangList,
        // getZhongGangCount
      },
      modals: {
        upload: {
          methods: {
            ok() {
              window.open(this.params.file);
            }
          },
          footer: {
            cancel: {
              isShow: true
            },
            ok: {
              name: this.$t("download_tem")
            }
          },
          config: {
            modalBind: {
              width: 500,
              draggable: true,
              maskClosable: false
            },
            rowBind: {
              gutter: 16
              // style: {
              //   marginBottom: "20px"
              // }
            },
            title: this.$t("upload") + this.$t("files")
          },
          grid: [{ files: 24 }],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx"
              },
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  let table = this.$refs["table"];
                  let modal = table.getModal("upload");
                  table
                    .handleRequestMethods(modal.params.fn, formData, true, true)
                    .then(res => {
                      table.getList();
                      table.getModal("upload").close();
                    });
                  return false;
                }
              }
            }
          ]
        },
        setFreight: {
          methods: {
            ok({ close }) {
              this.$page
                .handleRequestMethods(
                  "saveClaimFreight",
                  { check: this.list },
                  true,
                  true
                )
                .then(res => {
                  close();
                });
            }
          },
          footer: {
            ok: {
              id: 1237
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: this.$t("export"),
                type: "export",
                fnName: "export",
                bind: {
                  type: "primary"
                }
              }
            ],
            methods: {
              export() {
                console.log(this);
                this.$page.exportExc({
                  name: this.$route.name + "-" + this.$t("freight_fees"),
                  data: this.list,
                  fields: this.table.fields
                });
              }
            }
          },
          config: {
            modalBind: {
              width: 800
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("waybillNumber"),
                key: "airway_number",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("freight_fees"),
                key: "freight",
                minWidth: 130,
                bind: {
                  style: {
                    width: "100%"
                  }
                },
                component: "InputNumber"
              },
              {
                name: () => this.$t("currency_t"),
                key: "currency",
                minWidth: 130,
                bind: {
                  style: {
                    width: "100%"
                  }
                },
                component: "Select",
                options: [],
                methods: {
                  list: ({ field }) => {
                    field.options = this.selData["currency"];
                  }
                }
              },
              {
                name: () => this.$t("WhetherPayFreight"),
                key: "is_charge",
                minWidth: 130,
                bind: {
                  style: {
                    width: "100%"
                  }
                },
                component: "Select",
                options: [
                  { label: this.$t("YES"), value: 1 },
                  { label: this.$t("NO"), value: 2 }
                ],
                methods: {
                  list: ({ field }) => {
                    field.options = this.selData["is_charge"];
                  }
                }
              }
            ]
          }
        },
        auditOrder: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));

              if (data.verify_type !== 1 ? data.verify_status !== 1 : false) {
                for (const key in data) {
                  if (
                    key != "verify_type" &&
                    key != "verify_remarks" &&
                    key != "verify_remarks1" &&
                    key != "id"
                  ) {
                    delete data[key];
                  }
                }
              }
              this.$page
                .handleRequestMethods("auditClaim", data, true, true, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({ row }) {
                copyClick.copyToClipboard(row.airway_number, this);
              }
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            tableTop: true,
            modalBind: {
              width: "80%",
              styles: {
                top: "20px"
              }
            },
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;"
            },
            formBind: {
              labelWidth: 170
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              verify_type: [
                {
                  required: true,
                  type: "number",
                  message: "verify type agent cannot be empty",
                  trigger: "change"
                }
              ],
              actual_currency: [
                // {
                //   required: true,
                //   trigger: 'blur',
                //   message: '业务申请币种不能为空'
                // },
              ],
              actual_amount: [
                // {
                //   required: true,
                //   trigger: 'blur',
                //   message: '业务申请金额不能为空'
                // },
                // {
                //   validator: (rule, value, callback) => {
                //     if (value === "") {
                //       callback();
                //     } else if (value < 0) {
                //       callback(new Error("业务申请金额不能小于0"));
                //     } else {
                //       callback();
                //     }
                //   },
                //   trigger: "change"
                // }
              ],
              currency: [
                {
                  required: true,
                  message: "currency cannot be empty",
                  trigger: "change"
                }
              ],
              // amount: [
              //   {
              //     required: true,
              //     message: "amount cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_type: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty type cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_duty: [
              //   {
              //     required: true,
              //     message: "other duty cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_cause: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty cause cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_cause: [
              //   {
              //     required: true,
              //     message: "other cause cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // remarks: [
              //   {
              //     required: false,
              //     message: "remarks cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            {
              name: () => this.$t("feedbackArea"),
              show() {
                console.log(
                  this.$modal.params.is_special,
                  this.$modal.params.verify_status
                );
                return (
                  this.$modal.params.is_special == 1 &&
                  this.$modal.params.verify_status == 1
                );
              },
              render: (h, p) => {
                let modal = this.$refs["table"].getModal("auditOrder");
                let text = {
                  1: "请客服审核客户发起信息是否正确，界定责任方，并向责任方发起追赔。",
                  2: "请业务审核客户发起信息是否正确，参考客户发起理赔金额，填入公司赔偿客户金额，填写计算规则，金额的由来，等详细情况。",
                  3: "请财务在实际打款后，输入实际赔偿金额，并点击确认已打款"
                };
                let role = {
                  B2B客服: 1,
                  小包客服: 1,
                  小包主管: 1,
                  操作客服: 1,
                  业务员: 2,
                  业务经理: 2,
                  客服经理: 2,
                  客户管理: 2,
                  "总经理-多角色": 0,
                  财务经理: 3,
                  财务审核: 3
                };

                let user = modal.list.find(t => !t.create_time) || {};
                return h("span", {}, [
                  this.$t("feedbackArea"),
                  text[role[user.role]] &&
                    h(
                      "span",
                      {
                        style: "color:#f3c9c9;font-size:10px;margin-left:10px"
                      },
                      modal.params.tip + ":" + text[role[user.role]]
                    )
                ]);
              },
              span: 24,
              children: [{ verify_type: 24 }, { verify_remarks: 24 }]
            },
            {
              name: () => this.$t("feedbackArea"),
              show({ formData }) {
                return this.$modal.params.verify_status == 1
                  ? this.$modal.params.is_special != 1
                  : true;
              },
              render: (h, p) => {
                let modal = this.$refs["table"].getModal("auditOrder");
                let text = {
                  1: "请客服审核客户发起信息是否正确，界定责任方，并向责任方发起追赔。",
                  2: "请业务审核客户发起信息是否正确，参考客户发起理赔金额，填入公司赔偿客户金额，填写计算规则，金额的由来，等详细情况。",
                  3: "请财务在实际打款后，输入实际赔偿金额，并点击确认已打款"
                };
                let role = {
                  B2B客服: 1,
                  小包客服: 1,
                  小包主管: 1,
                  操作客服: 1,
                  业务员: 2,
                  业务经理: 2,
                  客服经理: 2,
                  客户管理: 2,
                  "总经理-多角色": 0,
                  财务经理: 3,
                  财务审核: 3
                };

                let user = modal.list.find(t => !t.create_time) || {};
                return h("span", {}, [
                  this.$t("feedbackArea"),
                  text[role[user.role]] &&
                    h(
                      "span",
                      {
                        style: "color:#f3c9c9;font-size:10px;margin-left:10px"
                      },
                      modal.params.tip + ":" + text[role[user.role]]
                    )
                ]);
              },
              span: 24,
              children: [
                { verify_type: 8, claim_type: 8 },
                { amount: 8, currency: 8 },
                { category: 6, quantity: 6, weight: 6, volume: 6 },
                {
                  remarks: 24
                },
                {
                  values: 8,
                  values_cny: 8,
                  customer_rule: 8
                },
                {
                  customer_explain: 24
                },
                {
                  freight: 8,
                  is_pay: 8,
                  pay_currency: 8
                },
                {
                  cod_amount: 8,
                  cod_currency: 8
                },
                {
                  is_claim_agent: 8
                  // is_claim_agent_status: 8,
                  // claim_agent_amount: 8,
                  // claim_agent_currency: 8
                },
                // {
                //   is_claim_agent_pay: 8,
                //   is_claim_agent_date: 8
                // },
                // {
                //   track_status: 8
                // },
                {
                  duty_type: 8,
                  number: 8,
                  duty: 8
                },
                {
                  other_duty: 8,
                  duty_cause: 8,
                  other_cause: 8
                },
                {
                  actual_quantity: 8,
                  actual_weight: 8,
                  actual_volume: 8
                },
                { is_values: 8, is_freight: 16 },
                { scheme_id: 8, other_scheme: 8, scheme_amount: 8 },
                { actual_currency: 8, actual_amount: 8 },
                { finance_amount: 8, finance_currency: 8 },
                { care_type: 24 },
                { memorandum: 24 },
                { verify_remarks: 24 },
                { verify_remarks1_btn: 24 },
                { verify_remarks1: 24 }
              ]
            }
          ],
          fields: [
            {
              key: "cod_amount",
              name: () => this.$tz("COD,金额"),
              component: "Input",
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "cod_currency",
              name: () => this.$tz("COD,币种"),
              component: "Input",
              disabled({ row }) {
                return true;
              }
            },
            {
              name: this.$tz("关注程度"),
              key: "care_type",
              component: "Select",
              placeholder: () => this.$tz("关注程度"),
              options: [],
              optionsFn: "caseType",
              optionsKey: "",
              default: ""
            },
            {
              name: () => this.$t("verify_status"),
              key: "verify_type",
              component: "Radio",
              options: [
                { label: this.$t("agree"), value: 1 },
                { label: this.$t("reject_prel"), value: 2 }
              ],
              bind: {
                border: true
              },
              show: ({ row }) => {
                if (row.is_special != 1 && row.verify_status == 1) return false;
                return row.is_show != 4;
              },
              methods: {
                "on-change": ({ value }) => {
                  // if (value == 2) {
                  // }
                }
              }
            },
            {
              key: "currency",
              name: () => this.$t("client_currency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("client_currency");
              },
              options: [],
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "amount",
              name: () => this.$t("client_amount"),
              component: "Input",
              bind: {
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("client_amount");
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ formData }) {
                return true;
              }
            },
            {
              key: "is_pay",
              name: () => this.$t("whether") + this.$t("payment_freight"),
              component: "Select",
              options: [
                { label: this.$t("is_paid"), value: 1 },
                { label: this.$t("unpaid"), value: 2 }
              ],
              disabled({ formData, row }) {
                return row.is_show != 5;
              }
            },
            {
              key: "pay_currency",
              name: () => this.$t("freight_fees") + this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("freight_fees") +
                  this.$t("currency_t")
                );
              },
              options: [],
              show({ row }) {
                return row.is_pay == 1;
              }
            },
            {
              key: "freight",
              name: () => this.$t("freight_fees"),
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return row.is_show != 5;
              }
            },
            {
              key: "values",
              name: () => this.$t("DeclaredValue") + "(USD)",
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "values_cny",
              name: () => this.$t("DeclaredValue") + "(CNY)",
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "remarks",
              name: () => this.$t("CustomerNote"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 1 }
              },
              placeholder() {
                return this.$t("CustomerNote");
              },
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "customer_rule",
              name: () => this.$t("claim") + this.$t("country_code_validation"),
              component: "Select",
              options: [],
              disabled({ formData }) {
                return true;
              }
            },
            {
              key: "customer_explain",
              name: () => this.$t("b2bClient") + this.$t("special_remark"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("b2bClient") +
                  this.$t("special_remark")
                );
              },
              show({ row }) {
                return row.customer_rule == 2;
              },
              disabled({ row }) {
                return true;
              }
            },
            {
              key: "actual_currency",
              name: () => this.$t("actual_currency"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("actual_currency");
              },
              options: [],
              show({ row }) {
                return row.is_show > 1;
              },
              disabled({ row }) {
                return row.is_show != 2;
              },
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                }
              }
            },
            {
              key: "actual_amount",
              name: () => this.$t("actual_amount"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("actual_amount");
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%"
              },
              show({ row }) {
                return row.is_show > 1;
              },
              disabled({ row }) {
                return row.is_show != 2;
              }
            },
            {
              key: "finance_currency",
              name: () => this.$t("finance_currency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("finance_currency");
              },
              options: [],
              show({ row }) {
                return row.is_show > 2;
              },
              disabled({ row }) {
                return row.is_show != 3;
              }
            },
            {
              key: "finance_amount",
              name: () => this.$t("finance_amount"),
              component: "Input",
              bind: {
                type: "number"
              },
              placeholder() {
                return this.$t("enter") + this.$t("finance_amount");
              },
              show({ row }) {
                return row.is_show > 2;
              },
              disabled({ row }) {
                return row.is_show != 3;
              }
            },
            {
              key: "duty_type",
              name: () => this.$t("Responsibility_party"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("Responsibility_party");
              },
              options: [],
              disabled({ row }) {
                return row.is_show != 1;
              },
              methods: {
                "on-change"({ value, fields, formData }) {
                  if (value) {
                    fields.forEach(async el => {
                      if (el.key == "duty") {
                        formData.duty = undefined;
                        let data = (
                          await getClaimDuty({
                            duty_type: value,
                            airway_number: formData.airway_number,
                            number: formData.number
                          })
                        ).data.payload;
                        formData["show_weight"] = data.show_weight;
                        fields.forEach(async el => {
                          if (
                            el.key == "duty" ||
                            el.key == "number" ||
                            el.key == "other_duty" ||
                            el.key == "duty_cause" ||
                            el.key == "other_cause"
                          ) {
                            formData[el.key] = undefined;
                            el.options = data[el.key];
                            this.$forceUpdate();
                          }
                        });
                      }
                    });
                  }
                }
              }
            },
            {
              key: "duty",
              name: () => this.$t("specific") + this.$t("Responsibility_party"),
              component: "Select",
              options: [],
              show({ row }) {
                return row.duty_type && row.duty_type != 99;
              },
              disabled({ row }) {
                return row.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("specific") +
                  this.$t("Responsibility_party")
                );
              }
            },
            {
              key: "show_weight",
              name: () => this.$t("whether") + this.$t("doubleList"),
              component: "Input",
              show({ row }) {
                return false;
              }
            },
            {
              key: "other_duty",
              name: () => this.$t("orther") + this.$t("Responsibility_party"),
              component: "Input",
              show({ row }) {
                return row.duty_type === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("orther") +
                  this.$t("Responsibility_party")
                );
              }
            },
            {
              key: "duty_cause",
              name: () => this.$t("Responsibility_party") + this.$t("reason"),
              component: "Select",
              options: [],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return row.is_show != 1;
              }
            },
            {
              key: "other_cause",
              name: () =>
                this.$t("orther") +
                this.$t("Responsibility_party") +
                this.$t("reason"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 1 }
              },
              show({ row }) {
                return row.duty_cause === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("orther") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              }
            },
            {
              name: () => this.$t("whether") + this.$t("claim_application"),
              key: "is_claim_agent",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 1
                },
                {
                  label: this.$t("NO"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 1
                }
              ],
              bind: {
                border: true
              }
            },
            // {
            //   name: () =>
            //     this.$t("Responsibility_party") +
            //     this.$t("whether") +
            //     this.$t("claim_acceptance"),
            //   key: "is_claim_agent_status",
            //   component: "Radio",
            //   options: [
            //     {
            //       label: this.$t("YES"),
            //       value: 1,
            //       disabled: ({ formData }) => formData.is_show != 1
            //     },
            //     {
            //       label: this.$t("NO"),
            //       value: 0,
            //       disabled: ({ formData }) => formData.is_show != 1
            //     }
            //   ],
            //   bind: {
            //     border: true
            //   },
            //   show({ row }) {
            //     return row.is_claim_agent;
            //   },
            //   disabled: ({ row }) => row.is_show != 1
            // },
            {
              key: "claim_agent_amount",
              name: () => this.$t("agent_claim") + this.$t("reChAmount"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("agent_claim") +
                  this.$t("reChAmount")
                );
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%"
              },
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1
            },
            {
              key: "claim_agent_currency",
              name: () => this.$t("agent_claim") + this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("agent_claim") +
                  this.$t("currency_t")
                );
              },
              options: [],
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1
            },
            {
              name: () => this.$t("whether") + this.$t("received_agent_claim"),
              key: "is_claim_agent_pay",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 1
                },
                {
                  label: this.$t("NO"),
                  value: 0,
                  disabled: ({ formData }) => formData.is_show != 1
                }
              ],
              bind: {
                border: true
              },
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1
            },
            {
              name: () => this.$t("received_agent_claim_date"),
              key: "is_claim_agent_date",
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("received_agent_claim_date");
              },
              show({ row }) {
                return row.is_claim_agent == 1 && row.is_claim_agent_pay;
              },
              disabled: ({ row }) => row.is_show != 1,
              bind: {
                type: "datetime",
                style: {
                  width: "100%"
                }
              }
            },

            {
              key: "quantity",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("invoicePCS"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              }
            },
            {
              key: "weight",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("invoiceWeight"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              }
            },
            {
              key: "volume",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("square"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              }
            },
            {
              key: "actual_quantity",
              name: () => this.$t("enter") + this.$t("order_pcs"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_pcs");
              }
            },
            {
              key: "number",
              name: () => this.$t("package_number"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("package_number");
              },
              methods: {
                "on-blur"({ value, fields, formData }) {
                  if (value) {
                    fields.forEach(async el => {
                      if (el.key == "duty") {
                        formData.duty = undefined;
                        let data = (
                          await getClaimDuty({
                            duty_type: formData.duty_type,
                            airway_number: formData.airway_number,
                            number: value
                          })
                        ).data.payload;
                        formData["show_weight"] = data.show_weight;
                        fields.forEach(async el => {
                          if (
                            el.key == "duty" ||
                            el.key == "other_duty" ||
                            el.key == "duty_cause" ||
                            el.key == "other_cause"
                          ) {
                            formData[el.key] = undefined;
                            el.options = data[el.key];
                            this.$forceUpdate();
                          }
                        });
                      }
                    });
                  }
                }
              }
            },
            {
              key: "actual_weight",
              name: () =>
                this.$t("service") +
                this.$t("confirm") +
                this.$t("invoiceWeight"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              }
            },
            {
              key: "actual_volume",
              name: () =>
                this.$t("service") + this.$t("confirm") + this.$t("square"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              }
            },
            {
              key: "category",
              name: () => this.$t("is_goods") + this.$t("category_t"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2 && row.category;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("is_goods") + this.$t("category_t")
                );
              }
            },
            {
              key: "claim_type",
              name: () => this.$t("application_reason"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 1
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("application_reason");
              }
            },
            {
              name: this.$t("indexes") + this.$t("order_desc"),
              key: "memorandum",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("email_subject") +
                  this.$t("related") +
                  this.$t("content")
                );
              },
              bind: {
                type: "textarea"
              }
            },
            {
              key: "verify_remarks",
              name: () => this.$tz("内部审核备注"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder({ formData }) {
                return (
                  this.$t("enter") +
                  (formData.is_show == 2
                    ? this.$t("remarkPlaceholder")
                    : this.$tz("内部审核备注"))
                );
              }
            },
            {
              key: "verify_remarks1_btn",
              name: () => this.$tz("推送客户备注"),
              component: "Button",
              show: ({ row, field }) => !field.isShow,
              isShow: false,
              methods: {
                render() {
                  return this.$tz("添加,备注");
                },
                click({ fields }) {
                  console.log(fields, "click");
                  fields.forEach(t => {
                    if (
                      ["verify_remarks1", "verify_remarks1_btn"].includes(t.key)
                    ) {
                      t.isShow = true;
                    }
                  });
                }
              }
            },
            {
              key: "verify_remarks1",
              name: () => this.$tz("推送客户备注"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder({ formData }) {
                return this.$tz("推送客户备注");
              },
              isShow: false,
              show: ({ row, field, value }) => field.isShow
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("DeclaredValue"),
              key: "is_values",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 2
                },
                {
                  label: this.$t("NO"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 2
                }
              ],
              bind: {
                border: true
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                }
              }
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("freight_fees"),
              key: "is_freight",
              component: "Radio",
              default: 0,
              options: [
                {
                  label: this.$t("zx"),
                  value: 0,
                  disabled: ({ formData }) => formData.is_show != 2
                },
                {
                  label: this.$t("ox"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 2
                },
                {
                  label: this.$t("tx"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 2
                }
              ],
              bind: {
                border: true
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                }
              }
            },
            {
              name: () => this.$t("special") + this.$t("plan_t"),
              key: "scheme_id",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("plan_t");
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                }
              }
            },
            {
              key: "other_scheme",
              name: () => this.$t("plan_t") + this.$t("causeDescription"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("plan_t") +
                  this.$t("causeDescription")
                );
              },
              show({ formData }) {
                return formData.scheme_id == 1;
              },
              disabled: ({ row }) => row.is_show != 2
            },
            {
              key: "scheme_amount",
              name: () => this.$t("plan_t") + this.$t("reChAmount"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("plan_t") + this.$t("reChAmount")
                );
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%"
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-blur": ({ row }) => {
                  this.getAmount(row);
                }
              }
            }
          ],
          table: {
            group: {
              render: (h, p) => {
                let modal = this.$refs["table"].getModal("auditOrder");
                return h("span", {}, [
                  this.$t("auditOrder") + this.$t("record"),
                  modal.params.process &&
                    h(
                      "span",
                      {
                        style: "color:#f3c9c9;font-size:10px;margin-left:10px"
                      },
                      modal.params.tip + ":" + modal.params.process
                    )
                ]);
              }
            },
            config: {
              height: 200
              // showOverflow: false,
            },
            fields: [
              {
                name: () => this.$t("approver"),
                key: "operate_name",
                tooltip: true,
                width: 140
              },
              {
                name: () => this.$t("approval_time"),
                key: "create_time",
                tooltip: true,
                width: 150
              },
              {
                name: () => this.$t("result"),
                key: "content",
                tooltip: true,
                width: 100
              },
              {
                name: () => this.$t("approval_remark"),
                key: "remarks",
                tooltip: true,
                minWidth: 200
              },
              {
                name: () => this.$t("role_t"),
                key: "role",
                tooltip: true,
                width: 120
              }
            ]
          }
        },
        record: {
          config: {
            listFn: "list",
            modalBind: {
              width: 800
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("approver"),
                key: "operate_name",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("approval_time"),
                key: "create_time",
                tooltip: true,
                minWidth: 130
              },
              {
                name: () => this.$t("result"),
                key: "content",
                tooltip: true,
                minWidth: 100
              },
              {
                name: () => this.$t("内部审核备注"),
                key: "remarks",
                tooltip: true,
                minWidth: 200
              },
              {
                name: () => this.$t("推送客户备注"),
                key: "remarks1",
                tooltip: true,
                minWidth: 200
              },
              {
                name: () => this.$t("role_t"),
                key: "role",
                tooltip: true,
                minWidth: 100
              }
            ]
          }
        },
        Replenish: {
          config: {
            modalBind: {
              width: 1000
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            formBind: {
              labelWidth: 80
            }
          },
          footer: {
            show: false
          },
          grid: [
            { src1: 8, src2: 8, src3: 8 },
            { remarks: 24 },
            { submit: 24 }
          ],
          fields: [
            {
              name: " ",
              key: "submit",
              component: "Button",
              bind: {
                type: "primary"
              },
              methods: {
                render() {
                  return this.$tz("提交");
                },
                click() {
                  let data = JSON.parse(JSON.stringify(this.formData));
                  data.src1 = this.formData.src1.src;
                  data.src2 = this.formData.src2.src;
                  data.src3 = this.formData.src3.src;
                  this.$page
                    .handleRequestMethods("addReplenish", data, true, true)
                    .then(() => {
                      this.$form.clear();
                      this.$page
                        .handleRequestMethods(
                          "getReplenish",
                          data.id,
                          false,
                          true
                        )
                        .then(res => {
                          this.$modal.list = res.payload;
                        });
                    });
                }
              }
            },
            {
              name: () => this.$tz("附件,1"),
              key: "src1",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select"
              },
              methods: {
                beforeUpload: ({ file, row, field }) => {
                  let table = this.$refs["table"];
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  formData.append("type", "claim"); // 文件对象
                  table
                    .handleRequestMethods("upload", formData, false, true)
                    .then(res => {
                      file.src = res.payload;
                      row[field.key] = file;
                    });
                  return false;
                }
              }
            },
            {
              name: () => this.$tz("附件,2"),
              key: "src2",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select"
              },
              methods: {
                beforeUpload: ({ file, row, field }) => {
                  let table = this.$refs["table"];
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  formData.append("type", "claim"); // 文件对象
                  table
                    .handleRequestMethods("upload", formData, false, true)
                    .then(res => {
                      file.src = res.payload;
                      row[field.key] = file;
                    });
                  return false;
                }
              }
            },
            {
              name: () => this.$tz("附件,3"),
              key: "src3",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select"
              },
              methods: {
                beforeUpload: ({ file, row, field }) => {
                  let table = this.$refs["table"];
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  formData.append("type", "claim"); // 文件对象
                  table
                    .handleRequestMethods("upload", formData, false, true)
                    .then(res => {
                      file.src = res.payload;
                      row[field.key] = file;
                    });
                  return false;
                }
              }
            },
            {
              name: () => this.$t("Replenish"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 2
              },
              placeholder() {
                return this.$t("Replenish");
              }
            }
          ],
          table: {
            config: {
              height: 600
            },

            header: {
              config: {
                hideSubmit: true
              },
              show() {
                return this.hasPermission(1523);
              }
            },
            fields: [
              {
                name: () => this.$t("Replenish"),
                key: "remarks",
                tooltip: true,
                minWidth: 200
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                tooltip: true,
                minWidth: 150
              },
              {
                name: () => this.$t("operation time"),
                key: "create_time",
                tooltip: true,
                minWidth: 150
              },
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    id: 1522
                  },
                  {
                    name: () => this.$tz("附件,1"),
                    type: "src1",
                    fnName: "file",
                    bind: {
                      type: "primary"
                    },
                    disabled: ({ row, field }) => !row[field.type]
                  },
                  {
                    name: () => this.$tz("附件,2"),
                    type: "src2",
                    fnName: "file",
                    bind: {
                      type: "primary"
                    },
                    disabled: ({ row, field }) => !row[field.type]
                  },
                  {
                    name: () => this.$tz("附件,3"),
                    type: "src3",
                    fnName: "file",
                    bind: {
                      type: "primary"
                    },
                    disabled: ({ row, field }) => !row[field.type]
                  }
                ],
                methods: {
                  file({ field, row }) {
                    this.openUrl(row[field.type]);
                  },
                  delete({ row, rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        console.log(this);
                        this.handleRequestMethods(
                          "delReplenish",
                          row.id,
                          true,
                          true
                        ).then(() => {
                          this.handleRequestMethods(
                            "getReplenish",
                            row.id,
                            false,
                            true
                          ).then(res => {
                            this.getModal("Replenish").list = res.payload;
                          });
                        });
                      }
                    });
                  }
                }
              }
            ]
          }
        },
        extend: {
          config: {
            listFn: "list",
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          header: {
            show: true,
            btns: [
              {
                name: this.$t("updateFile"),
                type: "upload",
                fnName: "upload",
                bind: {
                  type: "primary",
                  style: "margin-left:10px"
                }
              }
            ],
            methods: {
              upload({ row }) {
                let el = document.createElement("input");
                let that = this;
                let extend = [];
                let length = 0;
                el.type = "file";
                el.multiple = true;
                el.click();
                el.addEventListener("input", function(e) {
                  that.openLoading();
                  console.log(Object.values(this.files));
                  Object.values(this.files).forEach(file => {
                    let formData = new FormData();
                    formData.append("file", file); // 文件对象
                    uploadFile(formData)
                      .then(res => {
                        if (res.data.status) {
                          extend.push(res.data.payload);
                        }
                      })
                      .finally(() => {
                        length += 1;
                        if (length === this.files.length) {
                          that.$page
                            .handleRequestMethods("saveExtend", {
                              extend,
                              id: that.params.id
                            })
                            .then(res => {
                              that.closeLoading();
                              that.close();
                              that.$page.getList();
                            });
                        }
                      });
                  });
                });
                console.log("chufa");
              }
            }
          },
          fields: [],
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("Evidence_file") + this.$t("alipay_name"),
                key: "name",
                tooltip: true,
                minWidth: 100
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "show",
                    fnName: "showFun",
                    bind: {
                      type: "primary"
                    }
                  }
                ],
                methods: {
                  showFun({ row }) {
                    if (row.is_doc) {
                      window.open(this.$prviewUrl + row.src);
                    } else {
                      window.open(row.src);
                    }
                  }
                }
              }
            ]
          }
        },
        detail: {
          config: {
            title: "B2B" + this.$t("information"),
            formBind: {
              "label-position": "top"
            }
          },
          grid: [
            { quantity: 8, weight: 8, volume: 8 },
            { actual_quantity: 8, actual_weight: 8, actual_volume: 8 }
          ],
          fields: [
            {
              name: this.$t("invoicePCS"),
              key: "quantity",
              align: "center"
            },
            {
              name: this.$t("invoiceWeight") + "(KG)",
              key: "weight",
              align: "center"
            },
            {
              name: this.$t("square") + "(CBN)",
              key: "volume",
              align: "center"
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("invoicePCS"),
              key: "actual_quantity",
              align: "center"
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("Weight") +
                "(KG)",
              key: "actual_weight",
              align: "center"
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("square") +
                "(CBN)",
              key: "actual_volume",
              align: "center"
            }
          ],
          footer: { show: false }
        },
        binding: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("bindAuditUser", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              operate_id: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ operate_id: 24 }],
          fields: [
            {
              key: "operate_id",
              name: () => this.$t("auditOrder") + this.$t("personnel"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("auditOrder") +
                  this.$t("personnel")
                );
              },
              options: [],
              methods: {
                async list({ row, field }) {
                  await this.$nextTick(async () => {
                    let res = (await getBindUser(row.id)).data.payload;
                    field.options = res;
                    this.$forceUpdate();
                  });
                }
              }
            }
          ]
        },
        claim: {
          methods: {
            ok({ close, row, fields }) {
              row["extend"] = row["files"];
              this.$page
                .handleRequestMethods(
                  row.special
                    ? "specialApply"
                    : row.id
                    ? "editClaim"
                    : "addClaim",
                  row,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              this.fields.map(field => {
                if (field.key === "files") {
                  field.files = [];
                  field.extend = [];
                }
              });
            }
          },
          grid: [
            { client_id: 24 },
            { service_id: 24 },
            { verify_status: 24 },
            { airway_number: 24 },
            { order_type: 24 },
            { claim_type: 24 },
            { other_claim: 24 },
            { quantity: 8, weight: 8, volume: 8 },
            { currency: 12, amount: 12 },
            { is_charge: 12, is_freight: 12 },
            { freight_currency: 12, freight_amount: 12 },
            { is_values: 12, values: 12 },
            { scheme_id: 8, other_scheme: 8, scheme_amount: 8 },
            { remarks: 24 },
            { files: 24 }
          ],
          config: {
            formBind: {
              labelWidth: 110
            },
            width: 1000,
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              service_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              is_charge: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              freight_amount: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              freight_currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              order_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              verify_status: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              airway_number: [{ required: true }],
              claim_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number"
                }
              ],
              other_claim: [{ required: true }],
              currency: [{ required: true, trigger: "change" }],
              amount: [{ required: true, type: "number" }]
            }
          },
          fields: [
            {
              name: () => this.$t("WhetherPayFreight"),
              key: "is_charge",
              minWidth: 130,
              bind: {
                style: {
                  width: "100%"
                }
              },
              placeholder: () => this.$t("WhetherPayFreight"),
              component: "Select",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 2 }
              ],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData["is_charge"];
                }
              },
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("DeclaredValue"),
              key: "is_values",
              component: "Select",
              placeholder: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("DeclaredValue"),
              options: [
                {
                  label: this.$t("YES"),
                  value: 1
                },
                {
                  label: this.$t("NO"),
                  value: 2
                }
              ],
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: this.$tz("跟进客服"),
              key: "service_id",
              component: "Select",
              placeholder: () => this.$tz("跟进客服"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "",
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: this.$tz("运费币种"),
              key: "freight_currency",
              component: "Select",
              placeholder: () => this.$tz("运费币种"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "",
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: this.$tz("运费金额"),
              key: "freight_amount",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0,
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: this.$tz("申报价值"),
              key: "values",
              component: "InputNumber",
              bind: {
                border: true,
                min: 0,
                step: 0.01,
                style: "width:100%"
              },
              default: 0,
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: () => this.$t("special") + this.$t("plan_t"),
              key: "scheme_id",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("plan_t");
              },
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              key: "other_scheme",
              name: () => this.$t("plan_t") + this.$t("causeDescription"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("plan_t") +
                  this.$t("causeDescription")
                );
              },
              show({ row }) {
                return (
                  this.$modal.params.special && this.formData.scheme_id == 1
                );
              }
            },
            {
              key: "scheme_amount",
              name: () => this.$t("plan_t") + this.$t("reChAmount"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("plan_t") + this.$t("reChAmount")
                );
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%"
              },
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("freight_fees"),
              key: "is_freight",
              component: "Radio",
              default: 0,
              options: [
                {
                  label: this.$t("zx"),
                  value: 0
                },
                {
                  label: this.$t("ox"),
                  value: 1
                },
                {
                  label: this.$t("tx"),
                  value: 2
                }
              ],
              bind: {
                border: true
              },
              show({ row }) {
                return this.$modal.params.special;
              }
            },
            {
              name: () => this.$t("skipServiceCheck"),
              key: "verify_status",
              component: "Select",
              placeholder() {
                return this.$t("skipServiceCheck");
              },
              show() {
                return this.$page.checkSale && !this.$modal.params.special;
              },
              options: [
                { label: "YES", value: 2 },
                { label: "NO", value: 1 }
              ]
            },
            {
              name: this.$t("clientName"),
              key: "client_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              options: [],
              config: { label: "account", value: "id" },
              methods: {
                list: ({ field }) => {
                  field.options = this.client;
                }
              }
            },
            {
              name: () => this.$t("branchOffice"),
              key: "ownership",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("branchOffice");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.ownership;
                }
              }
            },
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: {
                  minRows: 2,
                  maxRows: 5
                }
              },
              methods: {
                "on-blur"({ formData, fields }) {
                  if (formData.airway_number && !formData.special)
                    this.$page
                      .handleRequestMethods("ordertype", {
                        airway_number: formData.airway_number
                      })
                      .then(res => {
                        formData.order_type = res.payload;
                        // this.$page.handleRequestMethods('getAmount',formData).then(res=>{
                        // 	fields.forEach((field)=>{
                        // 		if(field.key === 'is_pay'){
                        // 			field.remark = res.payload.txt
                        // 		}
                        // 	})
                        // 	Object.assign(formData,res.payload)
                        // })
                      })
                      .catch(err => {
                        formData.order_type = "";
                      });
                }
              }
            },
            {
              name: () => this.$t("claim") + this.$t("type"),
              key: "claim_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("claim") + this.$t("type");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.claim_type;
                }
              }
            },
            {
              name: () => this.$t("orther") + this.$t("reason"),
              key: "other_claim",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("orther") + this.$t("reason");
              },
              show({ row }) {
                return row.claim_type === 99;
              }
            },
            {
              name: () => this.$t("order_type_t"),
              key: "order_type",
              component: "Select",
              placeholder() {
                return this.$t("order_type_t");
              },
              disabled: true,
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.order_type;
                }
              },
              show({ row }) {
                return !this.$modal.params.special;
              }
            },
            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%"
              }
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              default: 0,
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%"
              }
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%"
              }
            },

            {
              name: this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea"
              }
            },
            {
              name: () => this.$t("claim") + this.$t("currency_t"),
              key: "currency",
              component: "Select",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("currency_t")
                );
              },
              options: [],
              show({ row }) {
                return !this.$modal.params.special;
              }
            },
            {
              name: () => this.$t("claim") + this.$t("reChAmount"),
              key: "amount",
              component: "InputNumber",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("reChAmount")
                );
              },
              default: 0,
              bind: {
                style: "width:100%"
              },
              show({ row }) {
                return !this.$modal.params.special;
              }
            },
            {
              name: () => this.$t("Evidence_file"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: "files",
                type: "drag",
                // accept: ".xlsx,.xls",
                multiple: true,
                content: this.$t("uploadText") + this.$t("uploadTe")
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                }
              },
              methods: {
                beforeUpload: ({ file, row }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  uploadFile(formData).then(res => {
                    if (res.data.status) {
                      if (row["files"]) {
                        row["files"].push({
                          name: file.name,
                          url: res.data.payload
                        });
                      } else {
                        row["files"] = [
                          {
                            name: file.name,
                            url: res.data.payload
                          }
                        ];
                      }
                    }
                  });
                  return false;
                }
              }
            }
          ]
        },
        batchClaim: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("setClaim", row, true)
                .then(res => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            rules: {
              traceker_code: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ traceker_code: 24 }],
          fields: [
            {
              key: "traceker_code",
              name: () => this.$t("whether") + this.$t("claim_application"),
              component: "Radio",
              bind: {
                border: true
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("whether") +
                  this.$t("claim_application")
                );
              },
              options: []
            }
          ]
        },
        batchAuditOrder: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods("batchAudit", data, true, true, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: "500"
            },
            formBind: {
              labelWidth: 110
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              verify_type: [
                {
                  required: true,
                  type: "number",
                  message: "verify type agent cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { verify_type: 24 },
            { verify_remarks: 24 },
            { verify_remarks1: 24 }
          ],
          fields: [
            {
              name: () => this.$t("verify_status"),
              key: "verify_type",
              component: "Radio",
              options: [
                { label: this.$t("agree"), value: 1 },
                { label: this.$t("reject"), value: 2 }
              ],
              bind: {
                border: true
              }
            },
            {
              key: "verify_remarks",
              name: () => this.$tz("内部审核备注"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$tz("内部审核备注");
              }
            },
            {
              key: "verify_remarks1",
              name: () => this.$tz("推送客户备注"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$tz("推送客户备注");
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "timeType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = await this.$sel.getData("CLAIM_DATE_TYPE");
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "service_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            clearable: true,
            options: [],
            // config: { label: "account", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "salesman_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "claim_type",
            placeholder() {
              return this.$t("select") + this.$t("claim") + this.$t("reason");
            },
            component: "Select",
            options: []
          },
          {
            key: "duty_type",
            placeholder() {
              return this.$t("select") + this.$t("Responsibility_party");
            },
            component: "Select",
            options: []
          },
          {
            key: "type",
            placeholder() {
              return this.$t("select") + this.$t("type");
            },
            component: "Select",
            options: []
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: []
          },
          {
            key: "duty_cause",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("Responsibility_party") +
                this.$t("reason")
              );
            },
            component: "Select",
            options: []
          },

          // {
          //   key: "status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("claim") + this.$t("tip");
          //   },
          //   component: "Select",
          //   options: []
          // },
          {
            key: "verify_id",
            placeholder() {
              return this.$tz("当前审批人");
            },
            component: "Select",
            options: []
          },
          {
            key: "verify_status",
            placeholder() {
              return this.$t("select") + this.$t("verify_status");
            },
            component: "Select",
            options: []
          },
          {
            key: "is_claim_agent",
            placeholder() {
              return this.$t("whether") + this.$t("claim_application");
            },
            component: "Select",
            options: []
          },
          {
            key: "node_type",
            placeholder() {
              return this.$t("select") + this.$t("claim") + this.$t("source");
            },
            component: "Select",
            options: []
          },
          // {
          //   key: "keywordsType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("keyword") + this.$t("type");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row }) {
          //       return this.$t(row.label);
          //     }
          //   },
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getKeysType("EXTRACT_SEA_KEYWORDS")).data
          //         .payload;
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_depart");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            clearable: true,
            options: [],
            config: { label: "code", value: "code" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input",
            default: this.$route.params.id ? this.$route.params.id : ""
          }
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download"
              }
            },
            {
              name: () => this.$t("launch") + this.$t("claim"),
              type: "claim",
              fnName: "claimFun",
              bind: {
                type: "warning",
                icon: "md-arrow-round-up"
              },
              id: 1271
            },
            {
              name: () => this.$t("launch") + this.$t("special_claim"),
              type: "specialClaim",
              fnName: "specialClaim",
              bind: {
                type: "warning",
                icon: "md-arrow-round-up"
              },
              id: 1663
            },
            {
              name: () => this.$t("generate_claim_bill"),
              type: "claimBill",
              fnName: "claimBillFun",
              bind: {
                type: "warning",
                icon: "md-arrow-round-up"
              },
              id: 985
            },
            {
              name: () => this.$t("batch_claim"),
              type: "batchClaim",
              fnName: "batchClaimFun",
              bind: {
                type: "success",
                icon: "logo-yen"
              },
              disabled(row) {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("batch") + this.$t("auditOrder"),
              type: "batchAudit",
              fnName: "batchAuditFun",
              bind: {
                type: "success",
                icon: "ios-people"
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 1105
            },
            {
              name: () =>
                this.$t("batch") + this.$t("setting") + this.$t("freight_fees"),
              type: "setFreight",
              fnName: "setFreight",
              bind: {
                type: "success",
                icon: "ios-people"
              },
              disabled() {
                return !this.selectAll.length;
              },
              id: 1238
            },
            {
              name: this.$t("UploadFreightAudit"),
              type: "upload",
              fnName: "upload",
              bind: {
                type: "primary"
              },
              data: "/doc/zh-CN/claim_freight.xlsx",
              id: 1470,
              fn: "uploadFreight"
            },
            {
              name: this.$tz("上传,财务,打款"),
              type: "uploadFinance",
              fnName: "upload",
              bind: {
                type: "primary"
              },
              data: "/doc/zh-CN/claim_finance.xlsx",
              fn: "uploadFinance",
              id: 1866
            }
            // disabled(row) {
            //   return !this.selectAll.length;
            //
          ],
          methods: {
            upload({ field }) {
              this.getModal("upload").open({
                file: field.data,
                fn: field.fn
              });
            },
            setFreight() {
              let ids = this.selectAll.map(item => item.id);
              this.handleRequestMethods("claimFreight", { ids }).then(res => {
                this.getModal("setFreight").open({ ids }, function() {
                  this.setTitle(
                    this.$t("batch") +
                      this.$t("setting") +
                      this.$t("freight_fees")
                  );
                  this.list = res.payload;
                });
              });
            },
            batchAuditFun({ row }) {
              this.getModal("batchAuditOrder").open(
                {
                  ids: this.selectAll.map(item => item.id)
                },
                function() {
                  this.setTitle(this.$t("batch") + this.$t("auditOrder"));
                }
              );
            },
            // analysisFun({ field, searchForm }) {
            //   this.getModal("analysis").open({}, function() {
            //     this.setTitle(this.$t("analysis"));
            //   });
            // },
            exportFun({ row, field, searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data["status"] = that.tabName;
              this.handleRequestMethods("exportClaim", data, true, true).then(
                res => {
                  window.open(res.payload.src);
                }
              );
            },
            claimBillFun({ searchForm }) {
              let data = {
                status: that.tabName,
                ...searchForm,
                ids: this.selectAll.map(item => item.id)
              };
              console.log(data);
              this.$Modal.confirm({
                title: this.$t("generate_claim_bill"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("createBill", data, true, true);
                }
              });
            },
            batchClaimFun() {
              this.getModal("batchClaim").open(
                { ids: this.selectAll.map(item => item.id) },
                function() {
                  this.setTitle(this.$t("batch_claim"));
                }
              );
            },
            claimFun() {
              this.getModal("claim").open({}, function() {
                this.setTitle(this.$t("launch") + this.$t("claim"));
              });
            },
            specialClaim() {
              this.getModal("claim").open({ special: true }, function() {
                this.setTitle(this.$t("launch") + this.$t("special_claim"));
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("Application_time"),
          key: "create_time",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("claim") + this.$t("source"),
          key: "note_type",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("Tracking number"),
          key: "airway_number",
          align: "center",
          header: {
            copy: true
          },
          minWidth: 120
        },
        {
          name: () => this.$t("placeOrder") + this.$t("time"),
          key: "order_time",
          align: "center",
          width: 160
        },
        {
          name: () => this.$t("b2bClient") + this.$t("accountNum"),
          key: "customer",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("claim") + this.$t("type"),
          key: "type_name",
          align: "center",
          minWidth: 120,
          methods: {
            render({ row }) {
              return row.type_name;
            }
          },
          render: (h, p) => {
            return h(
              "span",
              {
                style: {
                  color: p.row.type == 2 ? "#ed4014" : ""
                }
              },
              p.row.type_name
            );
          }
        },
        {
          name: this.$t("order_type_t"),
          key: "order_type",
          align: "center",
          tooltip: true,
          minWidth: 125,
          render(h, p) {
            return h(
              p.row.detail.order_type == 2 ? "Button" : "span",
              {
                on: {
                  click: () => {
                    if (p.row.detail.order_type == 2) {
                      this.getModal("detail").open(p.row);
                    }
                  }
                },
                attrs: {
                  size: "small",
                  type: "primary"
                }
              },
              p.row.order_type
            );
          }
        },
        {
          name: () => this.$t("claim") + this.$t("reason"),
          key: "claim_type",
          align: "center",
          minWidth: 120
        },
        {
          name: () => this.$t("claim") + this.$t("tip"),
          key: "status",
          align: "center",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.status_txt;
            }
          },
          render: (h, p) => {
            return h(
              "span",
              {
                style: {
                  color: this.getColor(p.row.status)
                }
              },
              p.row.status_txt
            );
          }
        },
        {
          name: () => this.$t("current_approver"),
          key: "verify_name",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("Responsibility_party"),
          key: "duty_type",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("whether") + this.$t("claim_application"),
          key: "track_status_txt",
          align: "center",
          width: 100
        },
        {
          name: () => this.$t("Responsibility_party") + this.$t("reason"),
          key: "duty_cause",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("verify_status"),
          key: "verify_status",
          align: "center",
          width: 150
        },
        {
          name: () => this.$t("client_currency"),
          key: "currency",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("client_amount"),
          key: "amount",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("actual_currency"),
          key: "actual_currency",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("actual_amount"),
          key: "actual_amount",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("finance_currency"),
          key: "finance_currency",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("finance_amount"),
          key: "finance_amount",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("freight_fees"),
          key: "freight",
          align: "center",
          minWidth: 130
        },
        {
          name: () => this.$t("b2bClient") + this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("indexes") + this.$t("order_desc"),
          key: "memorandum",
          align: "center",
          minWidth: 100
        },

        // {
        //   name: () => this.$t("Evidence_file"),
        //   key: "extend",
        //   align: "center",
        //   component: "Button",
        //   minWidth: 100,
        //   bind: {
        //     type: "primary",
        //     size: "small"
        //   },
        //   // render: (h, params) => {
        //   //   return h(
        //   //     "Button",
        //   //     {
        //   //       props: {
        //   //         type: "primary",
        //   //         size: "small"
        //   //       },
        //   //       on: {
        //   //         click: () => {
        //   //           console.log(this);
        //   //           this.$refs["table"]
        //   //             .getModal("extend")
        //   //             .open(null, function() {
        //   //               this.title = this.$t("Evidence_file");
        //   //               this.list = params.row.extend;
        //   //             });
        //   //         }
        //   //       }
        //   //     },
        //   //     this.$t("Evidence_file")
        //   //   );
        //   // },
        //   methods: {
        //     render({ value }) {
        //       return this.$t("Evidence_file");
        //     },
        //     click({ row }) {
        //       this.$page.getModal("extend").open({}, function() {
        //         this.title = this.$t("Evidence_file");
        //         this.list = row.extend;
        //       });
        //     }
        //   }
        // },
        {
          name: () => this.$t("claim") + this.$t("Odd_Numbers"),
          key: "claim_number",
          align: "center",
          minWidth: 220
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            // {
            //   name: () =>
            //     this.$t("update") + this.$t("branchOffice") + this.$t("claim"),
            //   type: "update",
            //   fnName: "updateFun",
            //   bind: {
            //     type: "warning"
            //   }
            //   // show: ({ row }) => {
            //   //   return row.is_bind == 1 && row.status;
            //   // }
            // },
            {
              name: () =>
                this.$t("bind") + this.$t("auditOrder") + this.$t("personnel"),
              type: "bindUser",
              fnName: "bindUserFun",
              bind: {
                type: "warning"
              },
              show: ({ row }) => {
                return row.is_bind == 1 && row.status;
              },
              id: 690
            },
            {
              name: () => this.$t("Evidence_file"),
              type: "extend",
              fnName: "extendFun",
              bind: {
                type({ row }) {
                  return row.extend && row.extend.length
                    ? "primary"
                    : "default";
                }
              }
            },
            {
              name: () => this.$t("auditOrder") + this.$t("record"),
              type: "record",
              fnName: "recordFun",
              bind: {
                type: "primary"
              },
              id: 679
            },
            {
              name: () => this.$t("auditOrder"),
              type: "auditOrder",
              fnName: "auditOrderFun",
              bind: {
                type: "success"
              },
              show: ({ row }) => {
                return row.is_verify && row.status;
              },
              id: 681
            },
            {
              name: () => this.$t("repeal") + this.$t("reject"),
              type: "repeal",
              fnName: "repeal",
              bind: {
                type: "warning"
              },
              show: ({ row }) => {
                return row.show_cancel_refuse == 1;
              },
              id: 1272
            },
            {
              name: () => this.$t("print"),
              type: "print",
              fnName: "printFun",
              bind: {
                type: "warning"
              },
              show: ({ row }) => {
                return row.is_print == 1;
              },
              id: 680
            },
            {
              name: () => this.$t("Replenish"),
              type: "Replenish",
              fnName: "Replenish",
              bind: {
                type: "primary"
              },
              id: 1524
            }
          ],

          methods: {
            Replenish({ row }) {
              this.handleRequestMethods(
                "getReplenish",
                row.id,
                false,
                true
              ).then(res => {
                this.getModal("Replenish").open({ id: row.id }, function() {
                  this.list = res.payload;
                  this.setTitle(this.$t("Replenish"));
                });
              });
            },
            repeal({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("repeal") +
                  this.$t("reject") +
                  `(${row.airway_number})`,
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "cancelRefuse",
                    row.id,
                    true,
                    true
                  ).then(res => {
                    this.getList();
                  });
                }
              });
            },
            updateFun({ row }) {
              let data = {
                ...row,
                ...row.detail,
                files: row.extend
              };
              this.getModal("claim").open(data, function() {
                this.setTitle(
                  this.$t("update") + this.$t("branchOffice") + this.$t("claim")
                );
              });
            },
            // exportFun({ row }) {
            //   console.log("导出");
            //   this.openLoading();
            //   this.handleRequestMethods(
            //     "getExportExcel",
            //     row.id,
            //     false,
            //     true
            //   ).then(res => {
            //     console.log(res);
            //     window.open(res.payload);
            //   });
            // },
            bindUserFun({ row }) {
              this.getModal("binding").open({ id: row.id }, function() {
                this.title =
                  this.$t("bind") +
                  this.$t("auditOrder") +
                  this.$t("personnel");
              });
            },
            extendFun({ row }) {
              this.getModal("extend").open({ id: row.id }, function() {
                this.title = this.$t("Evidence_file");
                this.list = row.extend;
              });
            },
            async recordFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id
              );
              this.getModal("record").open(null, function() {
                this.list = res.payload;
                this.setTitle(this.$t("auditOrder") + this.$t("record"));
              });
            },
            async auditOrderFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id,
                false,
                true
              );
              let data = JSON.parse(JSON.stringify(row.detail));
              data["id"] = row.id;
              data["is_show"] = row.is_show;
              data["claim_type"] = row.claim_type;
              data["airway_number"] = row.airway_number;
              data["process"] = row.process;
              // let data = {
              //   ...row,
              //   ...row.detail,
              //   row
              // };
              data.tip = row.verify_status;
              this.modals.auditOrder.fields.forEach(t => {
                if (
                  ["verify_remarks1", "verify_remarks1_btn"].includes(t.key)
                ) {
                  t.isShow = !!data.verify_remarks1;
                }
              });
              this.getModal("auditOrder").open(data, async function() {
                if (data.is_show == 4) this.hideFooter();
                else this.showFooter();
                this.list = res.payload;
                let list = data.type
                  ? (
                      await getClaimDuty({
                        duty_type: data.duty_type,
                        airway_number: data.airway_number,
                        number: data.number
                      })
                    ).data.payload
                  : {};
                this.fields.forEach(async item => {
                  if (item.key == "duty" || item.key == "duty_cause") {
                    item.options = list[item.key] ? list[item.key] : [];
                    this.$forceUpdate();
                  }
                  if (item.key == "verify_type") {
                    switch (row.work_type) {
                      case 1:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_prel"),
                            value: 2
                          }
                        ];
                        if (row.is_show == 2)
                          item.options.push({
                            label: this.$t("Completed"),
                            value: 3
                          });
                        break;
                      case 2:
                        item.options = [
                          {
                            label: this.$t("confirm") + this.$t("freight_fees"),
                            value: 1
                          }
                        ];
                        break;
                      case 3:
                        item.options = [
                          { label: this.$t("confirm_pay"), value: 1 }
                        ];
                        break;
                      default:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_client"),
                            value: 2
                          }
                        ];
                        if (row.is_show == 2)
                          item.options.push({
                            label: this.$t("Completed"),
                            value: 3
                          });
                        break;
                    }
                  }
                });
                this.setTitle(this.$t("auditOrder") + row.airway_number);
              });
            },
            printFun({ row }) {
              this.handleMethods("print", row.id);
            }
          }
        }
      ]
    };
  }
};
</script>
<style type="text/css">
.content {
  height: 100%;
}

/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}

.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}

.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}

.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
